import { useState, useEffect, useCallback } from 'react';
import { ref, onValue } from '../lib/firebase-database';
import { db } from '../firebase';

export function useQueryCount() {
  const [newQueriesCount, setNewQueriesCount] = useState(0);
  const [viewedQueries, setViewedQueries] = useState(new Set());

  useEffect(() => {
    const queriesRef = ref(db, 'userQueries');
    
    const unsubscribe = onValue(queriesRef, (snapshot) => {
      const queries = snapshot.val();
      if (!queries) {
        setNewQueriesCount(0);
        return;
      }

      const count = Object.entries(queries).reduce((acc, [id, query]) => {
        // Consider a query as unread if it's not read and not in viewedQueries
        if (!query.read && !viewedQueries.has(id)) {
          return acc + 1;
        }
        return acc;
      }, 0);

      setNewQueriesCount(count);
    });

    return () => unsubscribe();
  }, [viewedQueries]);

  const markQueriesAsViewed = useCallback((queryIds) => {
    setViewedQueries(prev => new Set([...prev, ...queryIds]));
    setNewQueriesCount(prev => Math.max(0, prev - queryIds.length));
  }, []);

  return { newQueriesCount, markQueriesAsViewed };
}